import i18next from 'i18next';
import {Product} from '../../backend/enums/product';
import {translations} from '../../i18n/translations';

/**
 * Returns the brand name according to the product
 */
export const getBrandName = (product?: Product): string => {
  switch (product) {
    case Product.Bluebird:
      return i18next.t(translations.products.bluebird);
    default:
      return '';
  }
};
